class Footer {
  constructor() {
    this.initialize();
  }

  initialize() {
    this.triggerAccessibe();
  }

  triggerAccessibe() {
    const dontClickAccessibe = document.querySelector('.dont-click-acsb');
    const selector = document.querySelector('.grist-accessibility');

    if (!dontClickAccessibe && null !== selector) {
      selector.addEventListener('click', event => {
        event.preventDefault();

        const accessibeSelector = document.querySelector('.acsb-trigger.acsb-bg-lead');

        if (null !== accessibeSelector) {
          accessibeSelector.click();
        }
      });
    }
  }
}

export default Footer;
